export default "__VITE_ASSET__CrzrLmEw__"